import { styled } from 'styled-components';

export const StyledAdmin = styled.div`
  color: ${({ theme }) => theme.colours.ink.primary.main};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.medium};
  width: 100%;

  h3 {
    ${({ theme }) => theme.typography.headingMedium}
    color: ${({ theme }) => theme.colours.ink.primary.main};
  }
`;

export const AccountDetails = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.small};
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  padding: ${({ theme }) => theme.sizing.medium};
  width: fit-content;

  p {
    ${({ theme }) => theme.typography.bodyMedium}

    span {
      ${({ theme }) => theme.typography.headingSmall}
    }
  }
`;

export const TableOfContents = styled.section`
  display: flex;
  gap: ${({ theme }) => theme.sizing.medium};
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  padding: ${({ theme }) => theme.sizing.medium};
  width: fit-content;
`;

export const TableOfContentsList = styled.div`
  h3 {
    padding-bottom: ${({ theme }) => theme.sizing.small};
  }

  ul {
    width: 130px;

    li {
      padding-bottom: ${({ theme }) => theme.sizing.tiny};
      ${({ theme }) => theme.typography.bodyMedium}

      a {
        color: ${({ theme }) => theme.colours.ink.primary.main};

        &:hover {
          color: ${({ theme }) => theme.colours.interface.strong};
          text-decoration: underline;
        }

        span {
          margin-left: ${({ theme }) => theme.sizing.small};
        }
      }
    }
  }
`;

StyledAdmin.displayName = 'StyledAdmin';
AccountDetails.displayName = 'AccountDetails';
TableOfContents.displayName = 'TableOfContents';
TableOfContentsList.displayName = 'TableOfContentsList';
